<template>
  <div class="container">
    <div class="handle-box">
      <el-form ref="queryForm" :model="queryForm" label-position="right" label-width="120px" class="searchForm">
        <el-row>
          <el-col :span="24">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item :label="$t('sensory.report.serialNo')" prop="serialNo">
                  <el-input class="handle-input" v-model="queryForm.serialNo" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('sensory.report.name')" prop="fiveBitCodeName">
                  <!-- <el-input class="handle-input" v-model="queryForm.fiveBitCodeName" clearable></el-input>-->
                  <!-- :fiveBitCode="{fiveBitCode:queryForm.fiveBitCode,fiveBitCodeName:queryForm.fiveBitCodeName}" -->
                  <PickupFiveBitCode ref="PickupFiveBitCode" clearable @clear="fiveBitCodeObj = {},queryForm.fiveBitCode=null,queryForm.fiveBitCodeName = null" @pickup="changeFiveBitCode" v-model="queryForm.fiveBitCodeName" :title="$t('sensory.report.name')"></PickupFiveBitCode>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('sensory.report.rateType')" prop="rateType">
                  <IcSelect table="TT_SENSORY" field="RATE_TYPE" v-model="queryForm.rateType" clearable style="width:100%"></IcSelect>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('sensory.report.status')" prop="status">
                  <IcSelect :excludes="excludesValue" table="TT_SENSORY_CALIBRATION" field="STATUS" v-model="queryForm.status" clearable style="width:100%"></IcSelect>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-collapse-transition>
            <el-col :span="24" v-if="isShow">
              <el-row :gutter="20">
                <el-col :span="6">
                  <!-- 我注释 -->
                  <!-- <el-form-item :label="$t('sensory.report.rateDate')" prop="rateDateArr">
                  <el-date-picker ref="rateDatePk" unlink-panels v-model="queryForm.rateDateArr" type="daterange" :range-separator="$t('sensory.report.to')" start-placeholder="开始日期" end-placeholder="结束日期" style="width:100%"></el-date-picker>
                </el-form-item> -->

                  <!-- 品评报告、品评人员校准，2个界面的查询条件评估日期，选择日期的方式不一致，建议优化为一致 -->
                  <!-- <el-form-item :label="$t('sensory.report.rateDate')" prop="rateDateBegin" style="float:left">
                            <el-date-picker style="width: 45%" value-format="yyyy-MM-dd" v-model="queryForm.rateDateBegin" type="date" :placeholder="$t('common.selDate')"></el-date-picker>
                            至
                            <el-date-picker style="width: 45%" value-format="yyyy-MM-dd" v-model="queryForm.rateDateEnd" type="date" :placeholder="$t('common.selDate')"></el-date-picker>
                        </el-form-item> -->
                  <el-form-item label="评估日期(从)" prop="rateDateBegin">
                    <el-date-picker value-format="yyyy-MM-dd" v-model="queryForm.rateDateBegin" type="date" :placeholder="$t('common.selDate')" style="width:100%"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="评估日期(至)" prop="rateDateEnd">
                    <el-date-picker value-format="yyyy-MM-dd" v-model="queryForm.rateDateEnd" type="date" :placeholder="$t('common.selDate')" style="width:100%"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="$t('nav.plant')" prop="tmPlantName">
                    <pickup-plant v-bind="fiveBitCodeObj" :plantName.sync="queryForm.tmPlantName" @pick-up="changePlant($event)" style="vertical-align: middle"></pickup-plant>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="$t('common.remarks')" prop="remark">
                    <el-input class="handle-input" v-model="queryForm.remark" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
          </el-collapse-transition>
        </el-row>
        <el-row type="flex" justify="center" align="middle">
          <el-button size="mini" type="primary" @click="getData(1)">{{$t("common.search")}}</el-button>
          <el-button size="mini" type="primary" @click="restQueryFormThis()">{{$t("common.reset")}}</el-button>
          <span class="arrowDown" @click="isShow=!isShow">{{isShow?'收缩':'展开'}}<i :class="isShow?'el-icon-arrow-up iconBtn':'el-icon-arrow-down iconBtn'"></i></span>
        </el-row>
      </el-form>
      <el-row v-if="!!!action" class="action-btn-row">
        <el-button size="mini" class="btn" type="primary" v-acl="CalibrationNew" v-show="emplFlag=='SUP'" @click="newReport">{{$t('sensory.calibration.addNew')}}</el-button>
        <el-button size="mini" class="btn" type="primary" v-acl="CalibrationInactive" v-show="emplFlag=='SUP'" @click="inactive">Inactive</el-button>
        <el-button size="mini" class="btn" type="primary" v-acl="CalibrationExport" @click="exportList">{{$t('sensory.report.export')}}</el-button>
        <el-button size="mini" class="btn" v-show="emplFlag!='SUP'" type="primary" v-acl="CalibrationDownloadCertificate" @click="downloadCertificate">{{$t('sensory.calibration.downloadCertificate')}}</el-button>
        <el-button size="mini" class="btn" v-show="emplFlag!='SUP'" type="primary" v-acl="CalibrationSendCertificates" @click="sendCertificates">{{$t('sensory.calibration.sendCertificates')}}</el-button>
        <el-button size="mini" class='btn' type="primary" @click="onRaterDetail" v-if="emplFlag!='SUP'">评估人主数据</el-button>

      </el-row>
      <el-row v-if="action == 'pickUp'" class="action-btn-row">
        <el-button type="primary" @click="pickUp">{{$t('common.select')}}</el-button>
      </el-row>
      <el-table :data="dataList" ref="dataList" border highlight-current-row max-height='420'>
        <el-table-column fixed min-width="56px" :label="$t('common.select')" align="center">
          <template slot-scope="scope">
            <el-radio v-if="!!!action" v-model="radioVal" @change.native="changeSelect(scope.row)" :label="scope.row.ttSensoryCalibrationId">&nbsp;</el-radio>
            <el-radio v-else :disabled="scope.row.status=='INACTIVE'" v-model="radioVal" @change.native="changeSelect(scope.row)" :label="scope.row.ttSensoryCalibrationId">&nbsp;</el-radio>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip fixed :label="$t('sensory.report.serialNo')" prop="serialNo">
          <template slot-scope="scope">
            <el-link class="el-link" v-if="$route.name!='sensoryCalibrationDetail'" @click="toDetail(scope.row.ttSensoryCalibrationId)">{{scope.row.serialNo}}</el-link>
            <span v-if="$route.name=='sensoryCalibrationDetail'">{{scope.row.serialNo}}</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip :label="$t('sensory.report.name')" prop="fiveBitCodeName"></el-table-column>
        <el-table-column show-overflow-tooltip :label="$t('sensory.report.rateType')" prop="rateType">
          <template slot-scope="scope">{{scope.row.rateType | ic("TT_SENSORY","RATE_TYPE")}}</template>
        </el-table-column>
        <el-table-column show-overflow-tooltip :label="$t('sensory.report.rateDate')" prop="rateDate">
          <template slot-scope="scope">{{scope.row.rateDate | dateFormatFilter("YYYY-MM-DD")}}</template>
        </el-table-column>
        <el-table-column show-overflow-tooltip :label="$t('sensory.report.status')" prop="statusI18n">
        </el-table-column>
        <el-table-column show-overflow-tooltip :label="$t('common.remarks')" prop="remark"></el-table-column>
        <el-table-column show-overflow-tooltip :label="$t('common.createTime')" prop="createDate">
          <template slot-scope="scope">{{scope.row.createDate | dateFormatFilter("YYYY-MM-DD")}}</template>
        </el-table-column>
        <el-table-column show-overflow-tooltip :label="$t('common.createBy')" prop="name"></el-table-column>
        <el-table-column show-overflow-tooltip v-if="this.emplFlag!='SUP'" :label="$t('sensory.calibration.certificateStatus')" prop="certificateStatusI18n"></el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination @size-change="pageSizeChange($event,'queryForm','getData')" @current-change="pageNumberChange($event,'queryForm','getData')" :current-page="queryForm.pageNum" :page-sizes="pageSizeList" :layout="pageLayout" :total="total"></el-pagination>
      </div>
    </div>
    <el-dialog :visible.sync="raterDialog" append-to-body width="80%" title="评估人主数据管理" :close-on-click-modal="false" :close-on-press-escape="false">
      <RaterDialog v-if="raterDialog"></RaterDialog>
    </el-dialog>
  </div>
</template>

<script>
import IcSelect from "@/components/common/icSelect";
import PickupUser from "@/components/page/visitPlan/pickupUser";
import dataTableUtils from "@/utils/dataTableUtils";
import commonFun from "@/utils/commonFun";
import calibrationApi from "@/api/sensory/calibration";
import { fileService } from "@/api/common/file-utils";
import { Message } from "element-ui";
import PickupFiveBitCode from "@/components/page/main-data/fiveBitCode/pickupFiveBitCode";
import PickupPlant from "@/components/page/sensory/pickupPlant";
import store from '@/store/index';
import paginationMixin from '@/mixins/pagitionMixin';
import RaterDialog from "../../sensory2/sensory-report/raterDialog.vue";
export default {
  mixins: [paginationMixin],
  components: { PickupPlant, PickupUser, IcSelect, PickupFiveBitCode, RaterDialog },
  props: {
    action: String,
  },
  data() {
    return {
      isShow: false,//控制查询列表收缩展开
      fiveBitCodeObj: {},
      queryForm: {
        pageSize: 15,
        pageNum: 1,
        serialNo: null,
        fiveBitCodeName: null,
        fiveBitCode: null,
        rateType: null,
        rateDateBegin: null,
        rateDateEnd: null,
        status: null,
        plantIds: null,
        rateDateBegin: null,
        rateDateEnd: null,
        remark: null,
        // rateDateArr: []
      },
      radioVal: null,
      selectRow: null,
      total: null,
      dataList: [],
      emplFlag: "",
      excludesValue: '',
      raterDialog: false,
    };
  },
  extends: dataTableUtils,
  watch: {
    queryForm() {
      let _this = this;
      store.dispatch('uploadListParams', { routeName: _this.$route.name, reqData: _this.queryForm })
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.queryForm = to.meta.reqData;
      vm.getData(1);
    })
  },
  created() {
    //this.getData(1);
    //用户所属系统(SUP供应商)
    this.emplFlag = localStorage.getItem("ms_emplFlag");
    //非供应商用户不显示草稿状态
    if (this.emplFlag != 'SUP') {
      this.excludesValue = 'SP_EDIT';
    }
  },
  methods: {
    pickUp() {
      if (commonFun.isEmpty(this.selectRow)) {
        Message.error(this.$t("common.pleaseSelectOneData"));
        return;
      }
      this.$emit("pickUp", this.selectRow);
    },
    getData(val) {
      if (undefined != val) {
        this.queryForm.pageNum = 1;
      }
      // let param = this.queryForm;
      // if (!commonFun.isEmpty(param.rateDate)) {
      //     param.rateDateBegin = param.rateDate[0];
      //     param.rateDateEnd = param.rateDate[1];
      // }
      // if (!commonFun.isEmpty(this.queryForm.rateDateArr)) {
      //   param.rateDateBegin = !!this.queryForm.rateDateArr ? this.$options.filters["dateFormatFilter"](this.queryForm.rateDateArr[0]) : "",
      //     param.rateDateEnd = !!this.queryForm.rateDateArr ? this.$options.filters["dateFormatFilter"](this.queryForm.rateDateArr[1]) : ""
      // }
      calibrationApi.list(this.queryForm).then(resp => {
        this.total = resp.totalCount;
        this.dataList = resp.resultData;
      });
    },
    newReport() {
      this.$router.push({ name: "newSensoryCalibration" });
    },
    onRaterDetail() {
      this.raterDialog = true
    },
    inactive() {
      let that = this;
      let selection = this.selectRow;
      if (selection == null) {
        that.$message({ message: that.$t("sensory.calibration.inactiveSelect"), type: "warning" });
        return;
      }
      that
        .$prompt(that.$t("sensory.calibration.inactiveReason"), "Inactive", {
          confirmButtonText: that.$t("common.confirm"),
          cancelButtonText: that.$t("common.cancel"),
          customClass: 'colorBtn',
          inputValidator: (val) => {
            if (val === null) {
              return that.$t('sensory.report.ReasonCannotEmpty');
            }
          },
          inputErrorMessage: that.$t("sensory.report.reasonTooLong")
          // ,type: "warning"
        })
        .then(msg => {
          if (commonFun.isEmpty(msg.value)) {
            that.$message("Reason cannot be empty!");
            return;
          }
          calibrationApi.inactive(selection.ttSensoryCalibrationId, msg.value).then(res => {
            that.getData()
          }

          );
        })
        .catch(() => {
        });
    },
    exportList() {
      let that = this;
      calibrationApi.exportExcel(that.queryForm);
    },
    changeSelect(row) {
      this.selectRow = row;
    },
    downloadCertificate() {
      if (commonFun.isEmpty(this.selectRow)) {
        Message.error(this.$t("common.pleaseSelectOneData"));
        return;
      }
      if (!(this.selectRow.certificateStatus == 'PASS' || this.selectRow.certificateStatus == 'SENDED')) {
        this.$message({ message: this.$t('sensory.calibration.downloadCertificateWarning'), type: "warning" });
        return;
      }
      let ttSensoryCalibrationId = this.selectRow.ttSensoryCalibrationId;
      calibrationApi.downloadCertificate(ttSensoryCalibrationId).then(resp => {
        fileService.respToFile(resp);
      });
    },
    sendCertificates() {
      if (commonFun.isEmpty(this.selectRow) || commonFun.isEmpty(this.selectRow.ttSensoryCalibrationId)) {
        Message.error(this.$t("common.pleaseSelectOneData"));
        return;
      }
      let ttSensoryCalibrationId = this.selectRow.ttSensoryCalibrationId;
      calibrationApi.sendCertificates(ttSensoryCalibrationId).then(resp => {
        Message.success(this.$t("sensory.calibration.sendCertificateSuccess"));
        this.getData();
      });
    },
    changeFiveBitCode(fiveBitCode) {
      this.fiveBitCodeObj = fiveBitCode;
      this.queryForm.fiveBitCode = fiveBitCode.fiveBitCode
      this.queryForm.fiveBitCodeName = fiveBitCode.fiveBitCodeName
    },
    changePlant(plant) {
      this.queryForm.plantIds = [plant.tmPlantId];
    },
    toDetail(id) {
      if (this.actionCheck.actionCheck('CalibrationSensoryCalibrationId') === false) {
        this.$message.error(this.$t('common.noPermission'))
        return false
      }
      let resolve = this.$router.resolve({
        path: `/sensoryCalibration-edit/${id}`
      });
      window.open(resolve.href, "_blank");
    },
    restQueryFormThis: function () {
      console.log('PickupFiveBitCode', this.$refs.PickupFiveBitCode)
      this.fiveBitCodeObj = {};
      this.queryForm = {
        pageSize: 15,
        pageNum: 1,
        serialNo: null,
        fiveBitCodeName: null,
        fiveBitCode: null,
        rateType: null,
        rateDateBegin: null,
        rateDateEnd: null,
        status: null,
        plantIds: null,
        rateDateBegin: null,
        rateDateEnd: null,
        remark: null,
        // rateDateArr: []
      }
      this.getData()
      this.$refs.PickupFiveBitCode.selectDataAll.fiveBitCode = ''
      this.$refs.PickupFiveBitCode.selectDataAll.fiveBitCodeName = ''
    }
  }
};
</script>
<style lang="scss">
.colorBtn .el-button {
  background: #f8ab01 !important;
  color: #fff !important;
  border-color: #f8ab01 !important;
}
.sensoryCalibrationList {
  .el-select {
    width: 100%;
  }
  .el-link {
    text-decoration: underline;
    color: #f8ab01 !important;
    cursor: pointer;
    font-size: 12px;
  }
  .queryForm {
    .el-form-item__content {
      .handle-input {
        width: 100%;
      }
      .el-autocomplete {
        width: 100%;
      }
      .el-date-editor {
        width: 100%;
      }
    }
  }
}
</style>
